export default {
    pusherClient: null,
}